import {Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {HttpClientModule, HttpClient, HttpRequest, HttpResponse, HttpEventType} from '@angular/common/http';
import {ModalService, PatientService} from '../../services';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-upload-file-document',
  templateUrl: './upload-file-document.component.html',
  styleUrls: ['./upload-file-document.component.scss']
})
export class UploadFileDocumentComponent implements OnInit {

  @Output() changeDocument = new EventEmitter();
  @Input() imei;
  @ViewChild('fileInput') fileInput;
  public document;
  public url;

  constructor
  (
      private translate: TranslateService,
      private modalService: ModalService
  ) {

  }

  ngOnInit() {}

  onFileChange(event) {
    const reader = new FileReader();
    if (event.target.files && event.target.files.length > 0) {
      const file = event.target.files[0];
      if (true) {
        if (file.size < 5000000) {

          reader.readAsDataURL(file);
          reader.onload = () => {

            this.document = {
              filename: file.name,
              filetype: file.type,
              size: file.size,
              imei: this.imei,
              value: reader.result.split(',')[1]
            };

            this.changeDocument.emit(this.document);


          };
        } else {
          this.modalService.open(this.translate.instant('DOCUMENTS.FILE_TOO_BIG'));
          this.document = null;
          this.fileInput.nativeElement.value = null;
          this.sendAvatar();
        }
      }
    }
  }

  // sprawdzamy czy nie mamy juz jakiegos avataru i wtedy do niego wracamy
  private sendAvatar(): void {

  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/upload-file-document/upload-file-document.component.ts